'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$Create$() {
}
export { $c_Lpresto_crud$Create$ as $c_Lpresto_crud$Create$ };
$p = $c_Lpresto_crud$Create$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$Create$;
/** @constructor */
function $h_Lpresto_crud$Create$() {
}
export { $h_Lpresto_crud$Create$ as $h_Lpresto_crud$Create$ };
$h_Lpresto_crud$Create$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 2026540316;
});
$p.l = (function() {
  return "Create";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Create";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_crud$Create$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$Create$, "presto.crud$Create$", ({
  VF: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_crud$Create$ as $d_Lpresto_crud$Create$ };
var $n_Lpresto_crud$Create$;
function $m_Lpresto_crud$Create$() {
  if ((!$n_Lpresto_crud$Create$)) {
    $n_Lpresto_crud$Create$ = new $c_Lpresto_crud$Create$();
  }
  return $n_Lpresto_crud$Create$;
}
export { $m_Lpresto_crud$Create$ as $m_Lpresto_crud$Create$ };
//# sourceMappingURL=presto.crud$-Create$.js.map
